<template>
  <div>
    <headerPage ></headerPage>
    <div style="text-align:left">
      <div style="position: relative;margin-top:5px;height:280px;color:white">
        <img
          style="width:100%;z-index:-1;left:0;top:20;position:absolute;height:280px;"
          src="@/assets/img/service_jgbackground.jpg"
          alt
        />
        <div style="width:1200px;margin:0 auto;padding-top:60px;">
          <div style="font-size:30px;">{{dataList.title}}</div>
          <div style="margin-top:35px;">{{dataList.content}}</div>
        </div>
      </div>
      <div style="height:130px;padding-top:60px; color: #1E2938">
        <div style="width:1200px;height:190px;margin:0 auto;position:relative">
          <div class="bar"></div>
          <div class="big" style="display:inline-block;margin-left:10px;">场景介绍</div>
          <div style="margin-top:27px;font-size:14px">{{dataList.content2}}</div>
        </div>
      </div>
      <div style="background:#F7F7F7;padding-top:60px; color: #1E2938">
        <div style="width:1200px;margin:0 auto;position:relative">
          <div class="bar"></div>
          <div class="big" style="display:inline-block;margin-left:10px;">系统架构</div>
          <div style="height:650px;background:#3385CF;margin-top:30px;"></div>
          <div
            style="margin-top:30px;color:#9299A1;position: relative;padding-bottom:60px; 
  vertical-align: center;"
          >
            <h3 style="color:#4F5A68">解决方案介绍</h3>
            <div style="margin-top:10px;line-height:20px;">
              <p v-for="(item,index) in dataList.keyDetail" :key="index">{{item.word}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <footerPage style="width:100%;"></footerPage>
  </div>
</template>
<script>
import Vue from "vue";
import headerPage from "@/components/header.vue";
import footerPage from "@/components/footer.vue";
export default {
  components: {
    headerPage,
    footerPage
  },
  created() {
    if (this.$route.query.index == 0) {
      this.dataList = this.firstData;
    } else if (this.$route.query.index == 1) {
      this.dataList = this.secondData;
    } else if (this.$route.query.index == 2) {
      this.dataList = this.thirdData;
    } else {
      this.dataList = this.fourthData;
    }
  },
  data() {
    return {
      dataList: {},
      firstData: {
        title: "连锁门店的解决方案",
        content: "解决零售业商家在大促期间流量和交易搞并发时",
        content2: "双11大促、年中促、99聚划算大促...",
        keyDetail: [
          { word: "1) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "2) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "3) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "4) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "5) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" }
        ]
      },
      secondData: {
        title: "商业综合体的解决方案",
        content: "解决零售业商家在大促期间流量和交易搞并发时",
        content2: "双11大促、年中促、99聚划算大促...",
        keyDetail: [
          { word: "1) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "2) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "3) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "4) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "5) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" }
        ]
      },
      thirdData: {
        title: "大型超市的解决方案",
        content: "解决零售业商家在大促期间流量和交易搞并发时",
        content2: "双11大促、年中促、99聚划算大促...",
        keyDetail: [
          { word: "1) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "2) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "3) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "4) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "5) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" }
        ]
      },
      fourthData: {
        title: "枢纽商铺的解决方案",
        content: "解决零售业商家在大促期间流量和交易搞并发时",
        content2: "双11大促、年中促、99聚划算大促...",
        keyDetail: [
          { word: "1) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "2) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "3) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "4) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" },
          { word: "5) 零售业务大促业务访问量高并发，EWS集成了运行环境管理、" }
        ]
      }
    };
  },
  methods: {}
};
</script>
<style scoped >
.bar {
  background: #1e2938;
  width: 4px;
  height: 21px;
  border-radius: 5px;
  position: absolute;
  top: 5px;
}
.big {
  font-size: 23px;
}
</style>


// WEBPACK FOOTER //
// src/view/detail.vue